module.exports = __webpack_public_path__ + "static/media/img128.4fc9556d.jpg";